import OddsConverter from 'odds-converter';

export default {
  install(Vue) {
    Vue.prototype.$todayTomorrow = function (displaydate, displayformat) {
      try {
        switch (this.$displayDate(displaydate, displayformat)) {
          case this.$displayDate(new Date().getDate(), displayformat):
            return "Today";
          case this.$displayDate(new Date().getDate() + 1, displayformat):
            return "Tomorrow";
          default:
            return this.$displayDate(displaydate, displayformat);
        }
      } catch (e) {
        console.log(e.message + " today/tomorrow");
      }
    };

    Vue.prototype.$removeTime = function (date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    Vue.prototype.$displayDate = function (displaydate, displayformat) {
      try {
        if (displaydate === undefined) displaydate = new Date();

        // IMPORTANT: navigator doesn't exist on server
        const ts =
          (typeof navigator !== "undefined" && navigator.language)
            ? navigator.language
            : "en-GB";

        const d = new Date(displaydate);

        const bumdates = [
          "1900-01-01T00:00:00",
          "2009-01-01T00:00:00",
          "2099-01-01T00:00:00",
          "1977-01-01T00:00:00",
        ];

        if (bumdates.includes(displaydate)) return "";

        let returnDate = "";

        if (String(d) !== "Invalid Date") {
          const dayno = d.getDate();
          const wr = checker(dayno);
          let monthname = d.toLocaleString(ts, { month: "short" });
          const monthnumber = d.toLocaleString(ts, { month: "numeric" });
          const timeonly = d.toLocaleString(ts, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
          });

          // NOTE: this assumes timediff exists
          const timediff =
  this.$store &&
  this.$store.state &&
  this.$store.state.timediff
    ? this.$store.state.timediff
    : 0;

const tzhours = d.getUTCHours() - Number(timediff / 60);
          d.setHours(tzhours);

          switch (displayformat) {
            case this.$dateformattype.daymonthshort:
              returnDate = dayno + "/" + monthnumber;
              break;

            case this.$dateformattype.timeonly:
            case this.$dateformattype.daytime:
            case this.$dateformattype.monthyear:
            case this.$dateformattype.yearonly:
            case this.$dateformattype.daymonthtime:
              returnDate = d.toLocaleTimeString(ts, displayformat);
              break;

            case this.$dateformattype.notime:
            case this.$dateformattype.dayshortmonthtime:
              monthname = d.toLocaleString(ts, { month: "short" });
              returnDate = dayno + wr + " " + monthname + " " + timeonly;
              break;

            case this.$dateformattype.daymonth:
              returnDate = dayno + wr + " " + monthname;
              break;

            default:
              returnDate = d.toLocaleDateString(ts, displayformat);
              break;
          }
        } else {
          console.log("Invalid Date - " + displaydate);
          returnDate = "";
        }

        return returnDate;
      } catch (e) {
        console.log(e.message);
        return "";
      }
    };

    Vue.prototype.$URLCreateTS = function (urlstub, img1, img2, sec2, prim1, t, id, compid) {
      let URL = "";

      if (urlstub === "Event") {
        URL = "/" + urlstub + "/" + csTS(img1) + "/" + csTS(img2) + "/" + csTS(sec2) + "/" + csTS(prim1) + "/" + csTS(t);
      } else if (urlstub === "Competition") {
        URL = "/" + urlstub + "/" + csTS(img1) + "/" +csTS(sec2);
      } else if (urlstub === "Outright") {
        URL = "/" + urlstub + "/" + csTS(img1) + "/"  + csTS(sec2);
      } else if (urlstub === "Sport") {
        URL = "/" + urlstub + "/" + csTS(img1) + "/All";
      } else if (urlstub === "Competitions") {
        URL = "/competition/" + id;
      } else if (urlstub === undefined || img2 === undefined) {
        URL = ".";
      }

      return URL;
    };

    Vue.prototype.$checkBeforeReroute = function (URL) {
      if (!URL || URL === "." || URL === "undefined") return;


      this.$router.push(URL).catch(err => {
        if (
          err.name !== "NavigationDuplicated" &&
          !err.message.includes("Avoided redundant navigation to current location")
        ) {
          // console.log(err)
        }
      });
    };

    Vue.prototype.$formatOddsTS = function (val, bn) {
      if (val < 1 || val == null) return "";

      switch (bn) {
        case "Betfair":
          val = (((100 - parseFloat(this.$store.state.betfaircom)) / 100) * val).toFixed(2);
          break;
        case "BetDaq":
          val = (((100 - parseFloat(this.$store.state.betdaqcom)) / 100) * val).toFixed(2);
          break;
        case "SMarkets":
          val = (((100 - parseFloat(this.$store.state.smarketcom)) / 100) * val).toFixed(2);
          break;
      }

      if (this.$store.state.currentot === this.$oddstype.decimal) return val;

      return this.$formatOdds(this, val, this.$store.state.currentot);
    };

    Vue.prototype.$uuidv4 = function () {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    };

    // MOVED INSIDE install() (was outside)
    Vue.prototype.$formatOdds = function (_this, val, changetodds) {
      if (changetodds === this.$oddstype.fractional) {
        const frac = OddsConverter.decimal.toFractional(val).simplify();
        if (frac.n > 1000) return val;
        return frac.n + "/" + frac.d;
      }
      if (changetodds === this.$oddstype.american) return OddsConverter.decimal.toAmerican(val);
      return "";
    };

    // MOVED INSIDE install() (was outside)
    Vue.prototype.$spaceandclean = function (val) {
      const valstandby = val;
      try {
        val = val.replace(/-/g, " ");
        val = val.replace(/~/g, " ");
        val = val.replace(/1./g, "");
        val = " " + val + " ";
      } catch {
        val = valstandby;
      }
      return val;
    };

    Vue.prototype.$checker = function (val) {
      if (val ==null | val===0)  return;
      return checker(val);
    }
  },
};


// helper functions (module scope is fine)
function csTS(val) {
  return String(val ?? "").replace(/\s+/g, "-");
}



function checker(x) {
  try {
    if (x > 3 && x < 21) return "th";
    switch (x % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  } catch (e) {
    console.log(e.message);
    return "th";
  }
}

